import _ from 'lodash';

const INITIAL_STATE = {
	loading: false,
	user: {},
	rectorIncentiveModal: false,
	activeRole: null
};

const reducers = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case "SET_LOADING":
			return{
				...state,
				loading: action.payload
			}
		case "SET_USER":
			return{
				...state,
				user: action.payload,
				// Set default activeRole when user logs in
				activeRole: action.payload?.role
			}
		case "SET_Rector_Incentive_Modal":
			return{
				...state,
				rectorIncentiveModal: action.payload
			}
		case "SET_ACTIVE_ROLE":
			return{
				...state,
				activeRole: action.payload
			}
        default:
			return state;
	}
};
export default reducers;